// extracted by mini-css-extract-plugin
export default {"LabelBox":"LabelBox_LabelBox__3zhyp","pointerEventNone":"LabelBox_pointerEventNone__o7xNu"};